"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const prop_types_1 = __importDefault(require("prop-types"));
const get_css_1 = __importDefault(require("../get-css"));
const regex_1 = require("../utils/regex");
exports.propTypes = {
    borderBottomLeftRadius: prop_types_1.default.oneOfType([
        prop_types_1.default.string,
        prop_types_1.default.number
    ]),
    borderBottomRightRadius: prop_types_1.default.oneOfType([
        prop_types_1.default.string,
        prop_types_1.default.number
    ]),
    borderRadius: prop_types_1.default.oneOfType([prop_types_1.default.string, prop_types_1.default.number]),
    borderTopLeftRadius: prop_types_1.default.oneOfType([
        prop_types_1.default.string,
        prop_types_1.default.number
    ]),
    borderTopRightRadius: prop_types_1.default.oneOfType([
        prop_types_1.default.string,
        prop_types_1.default.number
    ])
};
exports.propAliases = {
    borderRadius: [
        'borderBottomLeftRadius',
        'borderBottomRightRadius',
        'borderTopLeftRadius',
        'borderTopRightRadius'
    ]
};
exports.propValidators = {};
if (process.env.NODE_ENV !== 'production') {
    exports.propValidators.borderRadius = value => {
        if (regex_1.spacesOutsideParentheses.test(value)) {
            return `multiple values (“${value}”) aren՚t supported with “borderRadius”. Use “borderBottomLeftRadius”, “borderBottomRightRadius” “borderTopLeftRadius” and “borderTopRightRadius” instead.`;
        }
        return;
    };
}
const borderTopLeftRadius = {
    className: 'btlr',
    cssName: 'border-top-left-radius',
    jsName: 'borderTopLeftRadius'
};
const borderTopRightRadius = {
    className: 'btrr',
    cssName: 'border-top-right-radius',
    jsName: 'borderTopRightRadius'
};
const borderBottomLeftRadius = {
    className: 'bblr',
    cssName: 'border-bottom-left-radius',
    jsName: 'borderBottomLeftRadius'
};
const borderBottomRightRadius = {
    className: 'bbrr',
    cssName: 'border-bottom-right-radius',
    jsName: 'borderBottomRightRadius'
};
exports.propEnhancers = {
    borderBottomLeftRadius: (value) => get_css_1.default(borderBottomLeftRadius, value),
    borderBottomRightRadius: (value) => get_css_1.default(borderBottomRightRadius, value),
    borderTopLeftRadius: (value) => get_css_1.default(borderTopLeftRadius, value),
    borderTopRightRadius: (value) => get_css_1.default(borderTopRightRadius, value)
};
//# sourceMappingURL=border-radius.js.map